// src/utils/planning/planScheduler.js

/**
 * REHBER360 - YILLIK PLAN TAKVİM MOTORU
 *
 * Görevi:
 * annualPlanEngine tarafından oluşturulan mevcut
 * resmi faaliyetleri eğitim yılı içine dağıtmaktır.
 *
 * Bu motor:
 * - faaliyet üretmez,
 * - faaliyet adını değiştirmez,
 * - yalnızca tarih atar.
 */


// =========================================================
// 2026-2027 RESMÎ ÇALIŞMA TAKVİMİ
// =========================================================

export const SCHOOL_CALENDAR_2026_2027 = {

  academicYear: "2026-2027",

  version: "MEB-2026-2027-V1",

  firstTerm: {
    start: "2026-09-14",
    end: "2027-01-22"
  },

  firstBreak: {
    start: "2026-11-16",
    end: "2026-11-20"
  },

  semesterBreak: {
    start: "2027-01-25",
    end: "2027-02-05"
  },

  secondTerm: {
    start: "2027-02-08",
    end: "2027-06-25"
  },

  secondBreak: {
    start: "2027-03-08",
    end: "2027-03-12"
  }
};


// =========================================================
// TARİH YARDIMCILARI
// =========================================================

const toDate = (dateString) => {
  return new Date(`${dateString}T12:00:00`);
};


const toISODate = (date) => {

  const year =
    date.getFullYear();

  const month =
    String(
      date.getMonth() + 1
    ).padStart(2, "0");

  const day =
    String(
      date.getDate()
    ).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


const addDays = (
  date,
  days
) => {

  const result =
    new Date(date);

  result.setDate(
    result.getDate() + days
  );

  return result;
};


const isDateInRange = (
  date,
  start,
  end
) => {

  const current =
    date.getTime();

  return (
    current >=
      toDate(start).getTime() &&
    current <=
      toDate(end).getTime()
  );
};


// =========================================================
// TATİL HAFTASI MI?
// =========================================================

const isBlockedWeek = (
  monday,
  calendar
) => {

  const friday =
    addDays(monday, 4);

  const blockedRanges = [

    calendar.firstBreak,
    calendar.semesterBreak,
    calendar.secondBreak

  ];


  return blockedRanges.some(
    range => {

      const rangeStart =
        toDate(range.start);

      const rangeEnd =
        toDate(range.end);

      return (
        monday <= rangeEnd &&
        friday >= rangeStart
      );
    }
  );
};


// =========================================================
// TÜM KULLANILABİLİR OKUL HAFTALARINI ÜRET
// =========================================================

export const buildAvailableSchoolWeeks = (
  calendar =
    SCHOOL_CALENDAR_2026_2027
) => {

  const weeks = [];

  const schoolStart =
    toDate(
      calendar.firstTerm.start
    );

  const schoolEnd =
    toDate(
      calendar.secondTerm.end
    );


  let cursor =
    new Date(schoolStart);


  let weekNumber = 1;


  while (cursor <= schoolEnd) {

    const monday =
      new Date(cursor);

    const friday =
      addDays(monday, 4);


    if (
      !isBlockedWeek(
        monday,
        calendar
      )
    ) {

      weeks.push({

        id:
          `week_${weekNumber}`,

        weekNumber,

        startDate:
          toISODate(monday),

        endDate:
          toISODate(friday),

        month:
          monday.getMonth() + 1,

        year:
          monday.getFullYear(),

        term:
          isDateInRange(
            monday,
            calendar.firstTerm.start,
            calendar.firstTerm.end
          )
            ? 1
            : 2
      });


      weekNumber++;
    }


    cursor =
      addDays(cursor, 7);
  }


  return weeks;
};


// =========================================================
// ZAMAN KURALINA GÖRE ADAY HAFTALAR
// =========================================================

const getCandidateWeeks = ({
  timingRule,
  weeks
}) => {

  if (!timingRule) {
    return weeks;
  }


  // -------------------------------------------------------
  // DOĞRUDAN AY
  // -------------------------------------------------------

   if (
    timingRule.type === "month"
  ) {

    return weeks.filter(
      week =>
        week.month ===
        timingRule.month
    );
  }


  // -------------------------------------------------------
  // BELİRLİ OKUL HAFTASI
  //
  // week: 1 → okulun ilk aktif haftası
  // week: 2 → okulun ikinci aktif haftası
  //
  // Tatil haftaları buildAvailableSchoolWeeks içinde
  // zaten çıkarıldığı için burada "aktif okul haftası"
  // mantığı korunur.
  // -------------------------------------------------------

  if (
    timingRule.type ===
    "school_week"
  ) {

    const requestedWeek =
      Number(
        timingRule.week
      );


    if (
      !Number.isInteger(
        requestedWeek
      ) ||
      requestedWeek < 1
    ) {
      return [];
    }


    return weeks.filter(
      week =>
        week.weekNumber ===
        requestedWeek
    );
  }


  // -------------------------------------------------------
  // BELİRLİ AYIN AKTİF HAFTASI
  //
  // Örnek:
  //
  // {
  //   type: "month_week",
  //   month: 10,
  //   week: 1
  // }
  //
  // → Ekim ayındaki ilk aktif okul haftası
  // -------------------------------------------------------

  if (
    timingRule.type ===
    "month_week"
  ) {

    const requestedMonth =
      Number(
        timingRule.month
      );


    const requestedWeek =
      Number(
        timingRule.week
      );


    if (
      !Number.isInteger(
        requestedMonth
      ) ||
      requestedMonth < 1 ||
      requestedMonth > 12 ||
      !Number.isInteger(
        requestedWeek
      ) ||
      requestedWeek < 1
    ) {
      return [];
    }


    const monthWeeks =
      weeks.filter(
        week =>
          week.month ===
          requestedMonth
      );


    const selectedWeek =
      monthWeeks[
        requestedWeek - 1
      ];


    return selectedWeek
      ? [
          selectedWeek
        ]
      : [];
  }


  // -------------------------------------------------------
  // OKUL BAŞLANGICI
  // İlk dört aktif hafta
  // -------------------------------------------------------

  if (
    timingRule.type ===
    "school_start"
  ) {

    return weeks.slice(0, 4);
  }


  // -------------------------------------------------------
  // 1. DÖNEM BAŞI
  // -------------------------------------------------------

  if (
    timingRule.type ===
    "first_term_start"
  ) {

    return weeks
      .filter(
        week =>
          week.term === 1
      )
      .slice(0, 4);
  }


  // -------------------------------------------------------
  // 2. DÖNEM BAŞI
  // -------------------------------------------------------

  if (
    timingRule.type ===
    "second_term_start"
  ) {

    return weeks
      .filter(
        week =>
          week.term === 2
      )
      .slice(0, 4);
  }


  // -------------------------------------------------------
  // YIL SONU
  // -------------------------------------------------------

  if (
    timingRule.type ===
    "school_year_end"
  ) {

    return weeks.slice(-3);
  }


  // -------------------------------------------------------
  // DENGELİ DAĞIT
  //
  // Eylül → sene başı işleri
  // Kasım → risk haritası
  // Mayıs → RİBA
  // Haziran → yıl sonu
  //
  // olduğu için serbest çalışmalar mümkün olduğunca
  // Ekim-Aralık-Şubat-Mart-Nisan dönemine yayılır.
  // -------------------------------------------------------

    if (
    timingRule.type ===
    "balanced"
  ) {

    /*
     * Scheduler V2
     *
     * Ekim-Mayıs normal balanced havuzdur.
     *
     * Haziran tamamen kapatılmaz;
     * yalnızca ilk iki aktif hafta overflow
     * alanı olarak kullanılabilir.
     *
     * Böylece Mayıs'taki RİBA çalışmaları
     * balanced faaliyetleri otomatik olarak
     * dışlamaz; Haziran da gerektiğinde
     * takvim yükünü hafifletebilir.
     */

    const normalMonths = [
      10, // Ekim
      11, // Kasım
      12, // Aralık
      1,  // Ocak
      2,  // Şubat
      3,  // Mart
      4,  // Nisan
      5   // Mayıs
    ];


    return weeks.filter(
      week => {

        if (
          normalMonths.includes(
            week.month
          )
        ) {
          return true;
        }


        /*
         * Haziran'da yalnız ilk iki
         * aktif haftayı balanced faaliyetler
         * için kullan.
         */
        if (
          week.month === 6
        ) {

          const day =
            Number(
              week.startDate
                ?.slice(8, 10)
            );


          return (
            Number.isFinite(day) &&
            day <= 14
          );
        }


        return false;
      }
    );
  }


  return weeks;
};


// =========================================================
// EN UYGUN HAFTAYI SEÇ
// =========================================================

const chooseBestWeek = ({
  candidateWeeks,
  occupancy,
  monthOccupancy,
  seminarWeekOccupancy,
  seminarMonthOccupancy,
  balanceByMonth = false,
  isSeminar = false
}) => {

  if (
    !candidateWeeks ||
    candidateWeeks.length === 0
  ) {
    return null;
  }


  let workingWeeks = [
    ...candidateWeeks
  ];


  // =======================================================
  // SEMİNER GÜVENLİK / YOĞUNLUK KURALLARI
  // =======================================================

  if (isSeminar) {

    /*
     * 1. Mümkünse aynı haftaya
     * ikinci semineri ASLA koyma.
     */
    const weeksWithoutSeminar =
      workingWeeks.filter(
        week =>
          (
            seminarWeekOccupancy?.[
              week.id
            ] || 0
          ) === 0
      );


    if (
      weeksWithoutSeminar.length > 0
    ) {
      workingWeeks =
        weeksWithoutSeminar;
    }


    /*
 * 2. Ayda 2 seminer soft-cap.
 *
 * En az bir ay 0-1 seminerdeyse
 * 2 veya üzerindeki aya yeni
 * seminer ekleme.
 *
 * Ancak bütün kullanılabilir aylar
 * kapasiteye ulaşmışsa motor yine
 * çalışabilmek için fallback yapabilir.
 */
const weeksUnderMonthlyCap =
  workingWeeks.filter(
    week =>
      (
        seminarMonthOccupancy?.[
          week.month
        ] || 0
      ) < 2
  );


    if (
      weeksUnderMonthlyCap.length > 0
    ) {
      workingWeeks =
        weeksUnderMonthlyCap;
    }
  }


  const sorted =
    [...workingWeeks].sort(
      (a, b) => {

        // ===================================================
        // SEMİNERLERİ KENDİ İÇİNDE AYLARA DENGELE
        // ===================================================

        if (isSeminar) {

          /*
           * Haziran normal ay değil,
           * overflow alanıdır.
           *
           * +1 sanal yük sayesinde Haziran,
           * diğer aylarda yaklaşık 2 seminer
           * oluşmadan öne geçmez.
           */
         const aSeminarMonthCount =
  (
    seminarMonthOccupancy?.[
      a.month
    ] || 0
  ) +
  (
    a.month === 6
      ? 1
      : 0
  );


const bSeminarMonthCount =
  (
    seminarMonthOccupancy?.[
      b.month
    ] || 0
  ) +
  (
    b.month === 6
      ? 1
      : 0
  );


          if (
            aSeminarMonthCount !==
            bSeminarMonthCount
          ) {
            return (
              aSeminarMonthCount -
              bSeminarMonthCount
            );
          }
        }


        // ===================================================
        // GENEL AY YOĞUNLUĞU
        // ===================================================

        if (balanceByMonth) {

          /*
           * Balanced faaliyetlerde Haziran'ın
           * overflow niteliğini koruyoruz.
           */
        const aMonthCount =
  (
    monthOccupancy?.[
      a.month
    ] || 0
  ) +
  (
    a.month === 6
      ? 1
      : 0
  );


const bMonthCount =
  (
    monthOccupancy?.[
      b.month
    ] || 0
  ) +
  (
    b.month === 6
      ? 1
      : 0
  );


          if (
            aMonthCount !==
            bMonthCount
          ) {
            return (
              aMonthCount -
              bMonthCount
            );
          }
        }


        // ===================================================
        // HAFTANIN TOPLAM YOĞUNLUĞU
        // ===================================================

        const aCount =
          occupancy[a.id] || 0;

        const bCount =
          occupancy[b.id] || 0;


        if (
          aCount !==
          bCount
        ) {
          return (
            aCount -
            bCount
          );
        }


        // ===================================================
        // SON EŞİTLİKTE DAHA ERKEN TARİH
        // ===================================================

        return (
          toDate(
            a.startDate
          ) -
          toDate(
            b.startDate
          )
        );
      }
    );


  return sorted[0];
};

// =========================================================
// PLAN SATIRLARINI TAKVİME DAĞIT
// =========================================================

export const schedulePlanRows = ({
  rows = [],
  academicYear = "2026-2027"
} = {}) => {


  // -------------------------------------------------------
  // ŞİMDİLİK SADECE 2026-2027 AKTİF
  // -------------------------------------------------------

  if (
    academicYear !== "2026-2027"
  ) {

    return {

      success: false,

      rows: [],

      errors: [
        {
          code:
            "CALENDAR_NOT_SUPPORTED",

          message:
            `${academicYear} için çalışma takvimi henüz tanımlanmamış.`
        }
      ],

      warnings: []
    };
  }


  const calendar =
    SCHOOL_CALENDAR_2026_2027;


  const weeks =
    buildAvailableSchoolWeeks(
      calendar
    );


  const occupancy = {};


/*
 * Balanced faaliyetlerin yalnız haftalara değil,
 * aylara da dengeli dağılması için kullanılır.
 */
const monthOccupancy = {};


/*
 * Scheduler V2
 *
 * Seminerler genel faaliyet yükünden ayrı
 * olarak da takip edilir.
 *
 * Böylece:
 * - aynı haftaya iki seminer,
 * - aynı aya aşırı seminer
 *
 * yığılması önlenebilir.
 */
const seminarWeekOccupancy = {};

const seminarMonthOccupancy = {};


const scheduledRows = [];

  const warnings = [];


  // -------------------------------------------------------
  // PLAN SIRASINA GÖRE İŞLE
  // -------------------------------------------------------

  const orderedRows =
    [...rows].sort(
      (a, b) =>
        (a.order || 0) -
        (b.order || 0)
    );


  orderedRows.forEach(
    row => {

      const candidateWeeks =
        getCandidateWeeks({

          timingRule:
            row.timingRule,

          weeks
        });


           const isSeminar =
        row?.activityTypeId ===
          "seminar";


      const selectedWeek =
        chooseBestWeek({

          candidateWeeks,

          occupancy,

          monthOccupancy,

          seminarWeekOccupancy,

          seminarMonthOccupancy,

          balanceByMonth:
            row?.timingRule?.type ===
              "balanced",

          isSeminar

        });


      // ---------------------------------------------------
      // UYGUN HAFTA BULUNAMADI
      // ---------------------------------------------------

      if (!selectedWeek) {

        warnings.push({

          code:
            "SCHEDULE_WEEK_NOT_FOUND",

          activityId:
            row.activityId,

          message:
            `"${row.officialLabel}" için uygun takvim haftası bulunamadı.`
        });


        scheduledRows.push({
          ...row
        });

        return;
      }


      // ---------------------------------------------------
      // HAFTAYI DOLU SAY
      // ---------------------------------------------------

      occupancy[
        selectedWeek.id
      ] =
        (
          occupancy[
            selectedWeek.id
          ] || 0
        ) + 1;


monthOccupancy[
  selectedWeek.month
] =
  (
    monthOccupancy[
      selectedWeek.month
    ] || 0
  ) + 1;


/*
 * Seminer ise ayrıca seminer yükünü artır.
 */
if (isSeminar) {

  seminarWeekOccupancy[
    selectedWeek.id
  ] =
    (
      seminarWeekOccupancy[
        selectedWeek.id
      ] || 0
    ) + 1;


  seminarMonthOccupancy[
    selectedWeek.month
  ] =
    (
      seminarMonthOccupancy[
        selectedWeek.month
      ] || 0
    ) + 1;


  /*
   * Normal şartlarda yeni seçim mantığı
   * bunların oluşmasını engeller.
   *
   * Yine de takvim çok sıkışırsa
   * sessiz davranmak yerine warning bırak.
   */
  if (
    seminarWeekOccupancy[
      selectedWeek.id
    ] > 1
  ) {

    warnings.push({

      code:
        "MULTIPLE_SEMINARS_SAME_WEEK",

      activityId:
        row.activityId,

      message:
        `"${row.officialLabel}" aynı haftadaki ikinci seminere yerleştirildi.`

    });
  }


  if (
  seminarMonthOccupancy[
    selectedWeek.month
  ] > 2
) {

  warnings.push({

    code:
      "HIGH_MONTHLY_SEMINAR_LOAD",

    activityId:
      row.activityId,

    month:
      selectedWeek.month,

    message:
      `${selectedWeek.month}. ayda seminer yoğunluğu 2 çalışmayı aştı.`

  });
}
}


      // ---------------------------------------------------
      // TARİHLERİ ATA
      // ---------------------------------------------------

      scheduledRows.push({

        ...row,

        month:
          selectedWeek.month,

        startDate:
          selectedWeek.startDate,

        endDate:
          selectedWeek.endDate,

        scheduledWeek:
          selectedWeek.weekNumber
      });
    }
  );


  return {

    success: true,

    rows:
      scheduledRows,

    errors: [],

    warnings,

    calendarVersion:
      calendar.version
  };
};